import { Link } from 'react-router-dom';
import { Button } from '@tutor/ui';
import { useAuthStore } from '../stores/auth.store';

export function NotFoundPage() {
  const status = useAuthStore((state) => state.status);
  const homeRoute = useAuthStore((state) => state.homeRoute);
  const destination = status === 'authenticated' ? homeRoute() : '/';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-brand-600">404</p>
      <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-900">Page not found</h1>
      <p className="mt-2 max-w-sm text-sm text-slate-500">
        The page you were looking for does not exist, or you no longer have access to it.
      </p>
      <Link to={destination} className="mt-6">
        <Button>Go back</Button>
      </Link>
    </div>
  );
}
